import {
    fetchPostOpenBankingShareableLink,
    PostOpenBankingShareableLinkResponse
} from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export function usePostOpenBankingShareableLink() {
    const stateKey = useStateKey();

    const { mutateAsync, isLoading, isError, data } = useMutation<
        PostOpenBankingShareableLinkResponse,
        Error
    >({
        mutationFn: () => fetchPostOpenBankingShareableLink({ stateKey })
    });

    return {
        generateShareableLink: mutateAsync,
        isLoading,
        isError,
        link: data?.data?.link
    };
}
